import React, { useEffect, useState } from "react";
import "./mobileFilterWithDatePicker.scss";
import CustomModal from "../../../UI Component/Modal/ModalCustom";
import useDisableHelp from "../../../../Hooks/useDisableHelp";
import SearchBarWithIcon from "../SearchBarWithIcon";
import closeIcon from "../../../../assets/close.svg";

export default function MobileFilterWithDatePicker(props) {
  const {
    showMobileFilter,
    menuList,
    tickIcon,
    selectedTickIcon,
    selectedMenu,
    handleClose,
    openMobileMenuList,
    selectMobileFilterOptions,
    handleApplyFilter,
    handleResetAllFilter,
    handleFilterSearch,
    DateTimeRangeRender,
    placeholderForSearch,
    customSubmitText,
    customCancelText,
    customMenu,
  } = props;

  useDisableHelp();
  const [selectedValue, setSelectedValue] = useState();

  useEffect(() => {
    if (selectedMenu && selectedMenu.menuData?.length > 0) {
      selectedMenu.menuData.forEach((menu) => {
        if (menu.selected) {
          setSelectedValue(menu.value);
        }
      });
    }
  }, [selectedMenu]);

  // Display UI ===>

  const displayHeader = () => {
    return (
      <div className="d-flex col-sm-12 d-lg-none appointment-filter-header-div">
        <div className="appointment-filter-header-tittle-div">Filters</div>
        <div
          className="ml-auto appointment-filter-header-close"
          onClick={handleClose}
        >
          Close
          <img alt="" src={closeIcon} />
        </div>
      </div>
    );
  };

  const displayMenuHeader = () => {
    return (
      <div className={`appointment-filter-body-sidebar-div`}>
        {menuList.map((header, ind) => (
          <>
            {!header?.dontShowOnMobile && (
              <div
                key={ind}
                className={
                  "menu-title " +
                  (header.show_filter || header.showFilter
                    ? "selected-menu-title"
                    : "")
                }
                onClick={() => openMobileMenuList(header)}
              >
                {header.mobileFilterTitle}
              </div>
            )}
          </>
        ))}
      </div>
    );
  };

  const displayMenuList = () => {
    return (
      <div className="mfwdp-menu-list-container" style={{ overflowY: "auto" }}>
        {(selectedMenu?.show_filter_searchbar ||
          selectedMenu?.showFilterSearchbar) && (
          <div className="py-2">
            <SearchBarWithIcon
              inputCallBack={handleFilterSearch}
              placeholder={
                placeholderForSearch
                  ? placeholderForSearch
                  : `Search for ${selectedMenu?.title?.toLowerCase()}`
              }
              isClearable={true}
            />
          </div>
        )}
        {selectedMenu?.showCustomMenu ? (
          customMenu()
        ) : (
          <>
            {selectedMenu?.menuData?.map((menu, indM) => (
              <div
                key={indM}
                className="appointment-filter-body-right-div"
                onClick={() => {
                  selectMobileFilterOptions(menu);
                  setSelectedValue(menu.name);
                }}
              >
                {tickIcon ? (
                  <img
                    alt=""
                    src={menu.selected ? selectedTickIcon : tickIcon}
                    className="mobile-filter-menu-list-tick-icon"
                  />
                ) : (
                  <i
                    className={`fa fa-check mr-1 check-icon-filter ${
                      menu.selected ? "activeTab" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                )}
                <span>{menu.name}</span>
              </div>
            ))}
          </>
        )}
      </div>
    );
  };

  const displayBody = () => {
    return (
      <div
        className={`appointment-filter-body-div d-flex ${
          selectedValue === "Date Range"
            ? "appointment-filter-body-cal-div"
            : ""
        }`}
      >
        {displayMenuHeader()}
        {displayMenuList()}
      </div>
    );
  };

  const displayFooter = () => {
    return (
      <div className="d-flex col-sm-12 appointment-date-range-buttons-div p-2">
        <a
          className="ml-auto appointment-date-range-reset"
          onClick={handleResetAllFilter}
        >
          {customCancelText ?? "Reset All"}
        </a>
        <button
          className="ml-2 btn-primary appointment-date-range-apply"
          onClick={() => handleApplyFilter(selectedValue)}
        >
          {customSubmitText ?? "Apply"}
        </button>
      </div>
    );
  };

  // <===

  return (
    <CustomModal show={showMobileFilter}>
      <div className="customised-mobile-filter">
        {displayHeader()}
        {displayBody()}
        {selectedValue?.includes("Date Range") && (
          <div className="d-flex m-auto">{DateTimeRangeRender()}</div>
        )}
        {displayFooter()}
      </div>
    </CustomModal>
  );
}
